var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgLock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 9.3H19.1111C19.3469 9.3 19.573 9.39482 19.7397 9.5636C19.9064 9.73239 20 9.96131 20 10.2V20.1C20 20.3387 19.9064 20.5676 19.7397 20.7364C19.573 20.9052 19.3469 21 19.1111 21H4.88889C4.65314 21 4.42705 20.9052 4.26035 20.7364C4.09365 20.5676 4 20.3387 4 20.1V10.2C4 9.96131 4.09365 9.73239 4.26035 9.5636C4.42705 9.39482 4.65314 9.3 4.88889 9.3H6.66667V8.4C6.66667 6.96783 7.22857 5.59432 8.22876 4.58162C9.22896 3.56893 10.5855 3 12 3C13.4145 3 14.771 3.56893 15.7712 4.58162C16.7714 5.59432 17.3333 6.96783 17.3333 8.4V9.3ZM15.5556 9.3V8.4C15.5556 7.44522 15.181 6.52955 14.5142 5.85442C13.8474 5.17928 12.943 4.8 12 4.8C11.057 4.8 10.1526 5.17928 9.48584 5.85442C8.81905 6.52955 8.44444 7.44522 8.44444 8.4V9.3H15.5556Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lock.ed3e046716b337bad5bc86d5c57e114b.svg";